'use client'

import { useEffect } from 'react'
import { reportClientError } from '@/components/ErrorReporter'

// Only catches errors thrown in the root layout itself. Must render its own
// <html>/<body> because the root layout failed.
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    reportClientError({ name: error.name, message: error.message, stack: error.stack })
  }, [error])

  return (
    <html lang="ru">
      <body style={{ fontFamily: 'system-ui, sans-serif', padding: 24, textAlign: 'center' }}>
        <h1>Что-то пошло не так</h1>
        <p>Мы получили уведомление. Обновите страницу.</p>
      </body>
    </html>
  )
}
